import { Link, useLocation } from 'react-router-dom';

import { SidebarItemType } from 'types/sidebar';

type HeaderNavItemProps = {
  item: SidebarItemType;
};

function HeaderNavItem({ item }: HeaderNavItemProps) {
  const location = useLocation();
  const activeClass =
    location.pathname.split('/')[1] === item.path ? 'active' : '';
  return (
    <li className={'gnb_l1'}>
      <Link to={item.children[0].href} className={`gnb_a1 ${activeClass}`}>
        {item.name}
      </Link>
    </li>
  );
}

export default HeaderNavItem;
